module.exports = __webpack_public_path__ + "img/img_appscreen.0d5db69d.png";